import Card from '../ui/Card/Card'
import HtmlContent from '../ui/HtmlContent/HtmlContent'
import styles from './Disclaimer.module.scss'

const Disclaimer = ({ title, description }) => {
  return (
    <>
      {title || description ? (
        <Card className={styles.card}>
          {title && <span>{title}</span>}
          {description && (
            <HtmlContent
              content={description}
              contentClass={styles.listStyleMarkdown}
            />
          )}
        </Card>
      ) : null}
    </>
  )
}

export default Disclaimer
